export const ADD_INSIGHTS_VERSION_REQUEST = "ADD_INSIGHTS_VERSION_REQUEST";
export const ADD_INSIGHTS_VERSION_SUCCESS = "ADD_INSIGHTS_VERSION_SUCCESS";
export const ADD_INSIGHTS_VERSION_FAILURE = "ADD_INSIGHTS_VERSION_FAILURE";
